import { RelatorioPortariaItem } from "features/portaria/typings";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import moment from "moment";
import { formatBlocoQuadra } from "infra/helpers/formatBlocoQuadra";

function useRelatorioPortariaPdfColumns({
  includePessoaAcao,
}: {
  includePessoaAcao?: boolean;
}): PDFTableColumn<RelatorioPortariaItem>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<RelatorioPortariaItem>[] = [];

    columns.push({
      title: "Unidade",
      flexGrow: 0.7,
      render: (original) => {
        const { unidade, blocoQuadra } = original;
        return (
          <View>
            <Text>{formatBlocoQuadra(unidade?.numero, blocoQuadra?.nome)}</Text>
          </View>
        );
      },
    });

    columns.push({
      title: "Quem entrou",
      flexGrow: 1,
      render: (original) => (
        <View>
          <Text>{original.pessoa?.nome ?? "--"}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Responsável",
      flexGrow: 1,
      render: (original) => (
        <View>
          <Text>{original.pessoaResponsavel?.nome ?? "--"}</Text>
        </View>
      ),
    });

    if (includePessoaAcao) {
      columns.push({
        title: "Quem confirmou",
        flexGrow: 1,
        render: (original) => (
          <View>
            <Text>{original.pessoaAcao?.nome ?? "--"}</Text>
          </View>
        ),
      });
    }

    columns.push({
      title: "Data",
      flexGrow: 0.7,
      render: (original) => (
        <View>
          <Text>
            {original.data
              ? moment(original.data).format("DD/MM/YYYY HH:mm")
              : "--"}
          </Text>
        </View>
      ),
    });

    return columns;
  }, [includePessoaAcao]);
}

export default useRelatorioPortariaPdfColumns;
